import { all } from 'redux-saga/effects';
import { watchApp } from './sagas/app';
import { watchAdminForms } from './sagas/adminForms';
import { watchSettingsApprovals } from './sagas/settingsApprovals';
import { watchSettingsApp } from './sagas/settingsApp';
import { watchSettingsDatastore } from './sagas/settingsDatastore';
import { watchSettingsNotifications } from './sagas/settingsNotifications';
import { watchSettingsRobots } from './sagas/settingsRobots';
import { watchSettingsUsers } from './sagas/settingsUsers';
import { watchSettingsCalendars } from './sagas/settingsCalendars';

export default function* sagas() {
  yield all([
    watchApp(),
    watchAdminForms(),
    watchSettingsApp(),
    watchSettingsApprovals(),
    watchSettingsDatastore(),
    watchSettingsNotifications(),
    watchSettingsRobots(),
    watchSettingsUsers(),
    watchSettingsCalendars(),
  ]);
}
